import OktaEnrollGoogleAuth from "../components/okta/factor/OktaEnrollGoogleAuth";
import OktaEnrollWebAuthn from "../components/okta/factor/OktaEnrollWebAuthn";
import OktaEnrollOktaPush from "../components/okta/factor/OktaEnrollOktaPush";
import OktaEnrollOktaCall from "../components/okta/factor/OktaEnrollOktaCall";
import OktaEnrollOktaSms from "../components/okta/factor/OktaEnrollOktaSms";
import {Container} from "../components/common";
import {useParams} from "react-router-dom";
import OktaEnrollOktaEmail from "../components/okta/factor/OktaEnrollOktaEmail";
import OktaEnrollTotp from "../components/okta/factor/OktaEnrollTotp";
import OktaEnrollOktaTotp from "../components/okta/factor/OktaEnrollOktaTotp";

const MFAEnrollView = () => {
	let {provider, factorType} = useParams();

	return (
		<Container>
			{provider === "GOOGLE" && factorType === "token:software:totp" &&
				<OktaEnrollGoogleAuth/>}
			{provider === "FIDO" && factorType === "webauthn" && <OktaEnrollWebAuthn/>}
			{provider === "OKTA" && factorType === "push" && <OktaEnrollOktaPush/>}
			{provider === "OKTA" && factorType === "token:software:totp" && <OktaEnrollOktaTotp/>}
			{provider === "OKTA" && factorType === "sms" && <OktaEnrollOktaSms/>}
			{provider === "OKTA" && factorType === "call" && <OktaEnrollOktaCall/>}
			{provider === "OKTA" && factorType === "email" && <OktaEnrollOktaEmail/>}
			{provider === 'CUSTOM' && factorType === 'token:hotp' && <OktaEnrollTotp/>}
		</Container>
	);
}

export default MFAEnrollView;
